import { useState } from 'react';
import { FileText } from 'lucide-react';
import { storage } from '../services/firebase';
import { listItineraryOriginals } from '../utils/bookingDocuments';
import type { BookingDocument } from '../types';
import { BookingDocuments } from './BookingDocuments';

/** Lazy listing also covers destination-only imports, without a second document index. */
export function ItineraryOriginalDocuments({ tripId }: { tripId: string }) {
  const [docs, setDocs] = useState<BookingDocument[] | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [open, setOpen] = useState(false);
  async function toggle() {
    if (loading) return;
    if (open && !error) { setOpen(false); return; }
    setOpen(true);
    setLoading(true);
    setError(false);
    try { setDocs(await listItineraryOriginals(storage, tripId)); }
    catch { setError(true); }
    finally { setLoading(false); }
  }
  return <div className="space-y-3">
    <button type="button" onClick={toggle} disabled={loading} aria-expanded={open}
      className="flex items-center gap-2 py-2 text-sm text-app-sub hover:text-gold">
      <FileText className="w-4 h-4" />Original itinerary files
    </button>
    {open && (loading ? <p role="status" className="text-sm text-app-sub">Loading files…</p>
      : error ? <p role="alert" className="text-sm text-app-sub">Couldn’t load files. Tap above to try again.</p>
      : docs?.length ? <BookingDocuments docs={docs} label="Original itinerary files" />
      : <p className="text-sm text-app-sub">No original itinerary files saved here. Booking confirmations are on their saved items.</p>)}
  </div>;
}
